import WhyList from './WhyList';
import style from './WhySection.module.css';

const WhySection =()=>{

    return( 
    <section className={style.whySection}>
        <div className={style.whySectionTitle}>
        <h1 className={style.title}>
            Why choose Easybank?
        </h1>
        <p className={style.paragraph}>
                We leverage Open Banking to turn your bank account into 
                your financial hub. Control your finances like never before.
        </p>
        </div>
        <WhyList></WhyList>
    </section>
    )

}

export default WhySection;